import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

import { enumUserRole } from '@data-layer/enums/user';
import { enumApplicationMode } from '@enum/enumApplicationMode';
import { CompaniesService } from './companies.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationModeService {
  public onActiveApplicationModeChange$: BehaviorSubject<{ previous: enumApplicationMode; current: enumApplicationMode }>;

  public get activeApplicationMode(): enumApplicationMode {
    const fromStorage: string = localStorage.getItem('application_mode');
    return fromStorage === 'null' ? null : <enumApplicationMode>+fromStorage;
  }

  public set activeApplicationMode(appMode: enumApplicationMode) {
    const prevFromStorage: string = localStorage.getItem('application_mode');
    const previous: enumApplicationMode = prevFromStorage === 'null' ? null : <enumApplicationMode>+prevFromStorage;
    localStorage.setItem('application_mode', appMode.toString());
    this.onActiveApplicationModeChange$.next({ previous, current: appMode });
  }

  constructor(private router: Router, private companiesService: CompaniesService) {
    this.onActiveApplicationModeChange$ = new BehaviorSubject({ previous: null, current: null });
  }

  public setActiveApplicationModeByRole(role: enumUserRole): void {
    switch (role) {
      case enumUserRole.USER:
        this.activeApplicationMode = enumApplicationMode.USER;
        break;
      case enumUserRole.SUPPORT:
      case enumUserRole.CUSTOMS_BROKER:
        this.activeApplicationMode = enumApplicationMode.SUPPORT;
        break;
    }
  }

  public switchActiveApplicationMode(): void {
    const roles: enumUserRole[] = this.companiesService.getRoles();
    if (!roles || roles.length === 0) {
      return;
    }

    if (this.activeApplicationMode === enumApplicationMode.SUPPORT && roles.includes(enumUserRole.USER)) {
      this.activeApplicationMode = enumApplicationMode.USER;
      this.router.navigate(['/dashboard']);
    } else if (
      this.activeApplicationMode === enumApplicationMode.USER &&
      roles.some((role: enumUserRole) =>
        [enumUserRole.SUPPORT, enumUserRole.ADMIN, enumUserRole.SUPER_ADMIN, enumUserRole.CUSTOMS_BROKER].includes(role),
      )
    ) {
      this.activeApplicationMode = enumApplicationMode.SUPPORT;
      this.router.navigate(['/dashboard-management']);
    }
  }

  public isActiveApplicationModeFitToRoles(roles: enumUserRole[]): boolean {
    switch (this.activeApplicationMode) {
      case enumApplicationMode.USER:
        return roles.includes(enumUserRole.USER);
        break;
      case enumApplicationMode.SUPPORT:
        return roles.some((role: enumUserRole) =>
          [enumUserRole.SUPPORT, enumUserRole.ADMIN, enumUserRole.SUPER_ADMIN, enumUserRole.CUSTOMS_BROKER].includes(role),
        );
        break;

      default:
        return false;
    }
  }
}
